export default {
    isCurrentUserAdmin(state) {
        try {
            if (state.currentUser.role == "admin") {
                return true;
            }
        } catch (error) {
            return false;
        }
    },
    /**
     * DEPRECATED!
     * 
     * How to use:
     * 
     * return this.$store.getters['user/getCurrentUserDeliveryTeam'](this.nextFD.id);
     */
    getCurrentUserDeliveryTeam: (state) => (fdID) => {
        return state.currentUser.fd_team[fdID];
    },
    getCurrentUser(state) {
        return state.currentUser;
    },
    getCurrentUserID(state) {
        return state.currentUserID;
    },
    getUserData(state) {
        return state.userData;
    }
}